import { isSSR } from '@k2/core/util'
import type { NavigationGuardWithThis, RouteLocationRaw } from 'vue-router'
import { useProfileStore } from '../store'

// The router's half only: the API enforces `is_admin` per request (`apps/api/src/admin.ts`).
export const adminGuard: NavigationGuardWithThis<undefined> = async () => {
  if (isSSR) return true

  const store = useProfileStore()
  await store.load()

  if (store.profile?.isAdmin) return true
  return { name: 'organizations' } as RouteLocationRaw
}
